import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Popper from '@mui/material/Popper';
import withTranslate from '../../containers/widgets/withTranslate';
import css from './DimensionDrilldownPopover.css';
import DropdownBody from '../molecules/DropdownBody';

function BaseDimensionDrilldownPopover({
    dimensionList,
    nodeData,
    anchorEl = null,
    showPopover,
    closePopover,
    onDimensionSelection,
    translate,
}) {
    const [tooltipMsg, setTooltipMsg] = useState();
    const [tooltipAnchorEl, setTooltipAnchorEl] = useState();
    const popoverRef = useRef(null);

    useEffect(() => {
        const onClick = event => !popoverRef.current?.contains(event.target) && closePopover();
        document.addEventListener('click', onClick, { capture: true });
        return () => document.removeEventListener('click', onClick, { capture: true });
    }, [closePopover]);

    const handleDimensionSelection = event => {
        const dimensionField = dimensionList.find(item => event.target.id === item.name);

        if (!dimensionField.disabled) {
            onDimensionSelection(dimensionField, nodeData);
        }
    };

    const handleDimensionMouseEnter = event => {
        const dimension = dimensionList.find(item => event.target.id === item.name);
        setTooltipMsg(dimension.tooltipMsg);
        setTooltipAnchorEl(event.target);
    };

    const handleDimensionMouseLeave = () => {
        setTooltipMsg(undefined);
    };

    const items = dimensionList.map(dimension => {
        return dimension.disabled
            ? {
                  ...dimension,
                  onMouseEnter: handleDimensionMouseEnter,
                  onMouseLeave: handleDimensionMouseLeave,
              }
            : { ...dimension };
    });

    return (
        <Popper open={showPopover} anchorEl={anchorEl} placement="bottom-end" style={{ zIndex: 1500 }}>
            <div className={css.popover} ref={popoverRef}>
                <div className={css.header}>{translate('STATIC.PAGES.REPORTS.DIMENSION_DRILLDOWN_HEADER')}</div>
                <DropdownBody
                    hideTopBorder
                    showButton={false}
                    translate={translate}
                    items={items}
                    className={css.dropdownBody}
                    onSelection={handleDimensionSelection}
                />
                <Popper anchorEl={tooltipAnchorEl} placement="top-start" open={!!tooltipMsg}>
                    <div className={css.tooltip}>{translate(tooltipMsg || '')}</div>
                </Popper>
            </div>
        </Popper>
    );
}

BaseDimensionDrilldownPopover.propTypes = {
    dimensionList: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired,
            disabled: PropTypes.bool,
            tooltipMsg: PropTypes.string,
        })
    ).isRequired,
    nodeData: PropTypes.shape({}).isRequired,
    anchorEl: PropTypes.instanceOf(Element),
    showPopover: PropTypes.bool.isRequired,
    closePopover: PropTypes.func.isRequired,
    onDimensionSelection: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withTranslate(BaseDimensionDrilldownPopover);
